import React, { useEffect, useState } from "react";
import MyBreakcrumbs from "../components/MyBreadcrumbs";
import MyTable from "../components/MyTable";
import SearchInput from "../components/SearchInput";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import {
  downloadFile,
  formatDateGlobal,
  getStartOrEndOfDay,
} from "../utils/commonUtils";
import { getClinicIdFromToken } from "../utils/tokenUtils";
import {
  fetchPaymentsByClinicId,
  serviceFetchDoctorsList,
} from "../services/api";
import CustomSelect from "../components/CustomSelect";
import { paymentMethodOptions } from "../utils/commonData";
import { StatusOptions } from "../utils/commonData";
import { showToast } from "../utils/toastUtils";
import dayjs from "dayjs";
import AntDatePicker from "../components/antDatepicker";
import { filter } from "lodash";

const Payment = () => {
  const navigate = useNavigate();
  const [payments, setPayments] = useState([]);
  const [status, setStatus] = useState([]);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedDoctors, setSelectedDoctors] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [filterInput, setFilterInput] = useState("");
  const [isDoctorFilterOpen, setIsDoctorFilterOpen] = useState(false);
  const [filteredPayments, setFilteredPayments] = useState([]);
  const [filteredStatus, setFilteredStatus] = useState([]);

  const [startDate, setStartDate] = useState(
    dayjs(getStartOrEndOfDay(new Date(), "start"))
  );
  const [endDate, setEndDate] = useState(
    dayjs(getStartOrEndOfDay(new Date(), "end"))
  );
  const [selectedTab, setSelectedTab] = useState("today");
  const [showFilters, setShowFilters] = useState(false);

  const columns = [
    { Header: "ID", accessor: "paymentid", className: "hidden md:table-cell" },
    { Header: "Invoice ID", accessor: "invoiceid", className: "hidden md:table-cell" },
    { Header: "Patient", accessor: "patientname" },
    {
      Header: "Date",
      accessor: "paymentdate",
      className: "hidden md:table-cell",
      Cell: ({ value }) => formatDateGlobal(value),
    },
    { Header: "Amount", accessor: "amount" },
    { Header: "Mode", accessor: "paymentmethod" },
    { Header: "Channel", accessor: "paymentchannel", className: "hidden md:table-cell" },
    { Header: "Notes", accessor: "notes", className: "hidden md:table-cell" },
    {
      Header: "Doctor",
      accessor: "doctorid",
      Cell: ({ value }) => {
        const doctor = doctors.find((doctor) => doctor.doctor_id === value);
        return doctor ? `${doctor.first_name} ${doctor.last_name}` : "";
      },
    },
    {
      Header: "Status",
      accessor: "paymentstatus",
      Cell: ({ value }) => {
        // Determine status based on the value of isInvalidated
        const status = value ? "Invalid" : "Valid";
        return status;
      },
    },
  ];

  const DoctorFilterDropdown = ({ options, selectedOptions, onChange }) => {
    const handleCheckboxChange = (event, option) => {
      if (event.target.checked) {
        onChange([...selectedOptions, option.value]); // Ensure we're working with doctor IDs directly
      } else {
        onChange(selectedOptions.filter((opt) => opt !== option.value));
      }
    };

    const isChecked = (option) => {
      return selectedOptions.includes(option.value); // Check if doctor_id is in selectedOptions
    };
    return (
      <div className="relative">
        <button
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          onClick={() => setIsDoctorFilterOpen(!isDoctorFilterOpen)}
        >
          Filter by Doctor
        </button>
        {isDoctorFilterOpen && (
          <div className="absolute z-30 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
            <div
              className="py-1"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="options-menu"
            >
              {options.map((option) => (
                <label
                  key={option.value}
                  className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                  role="menuitem"
                >
                  <input
                    type="checkbox"
                    checked={isChecked(option)}
                    onChange={(e) => handleCheckboxChange(e, option)}
                    className="mr-2 h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  />
                  {option.label}
                </label>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    fetchDoctors();
  }, []);

  useEffect(() => {
    console.log("status!!", status)
    // Filter payments based on selected doctors
    const filteredPayments = payments.filter(
      (payment) =>
        (selectedDoctors.length === 0 || selectedDoctors.includes(payment.doctorid))
    );


    // Filter status based on selected doctors and selected status
    const filteredStatus = status
      .filter((statusItem) => {
        // Filter based on selected doctors
        return selectedDoctors.length === 0 || selectedDoctors.includes(statusItem.doctorid);
      })
      .map((statusItem) => {
        // Map to a new object with status based on paymentStatus
        return {
          ...statusItem,
          paymentstatus: statusItem.isInvalidated === true ? 'Invalid' : 'Valid',
        };
      });
    console.log("filteredPayments", filteredPayments)
    console.log("filteredStatus", filteredStatus)
    const filteredfinalStatus = filteredStatus.filter(
      (payment) =>
        (selectedDoctors.length === 0 || selectedDoctors.includes(payment.doctorid))
    );

    setFilteredPayments(filteredPayments);
    setFilteredStatus(filteredfinalStatus);
  }, [payments, status, selectedDoctors, selectedStatus]);


  useEffect(() => {
    handlefetchPaymentsByClinicId();
  }, [selectedTab, startDate, endDate, selectedPaymentMode, selectedStatus]);

  const fetchDoctors = async () => {
    try {
      const clinicId = getClinicIdFromToken();
      const response = await serviceFetchDoctorsList(clinicId);
      if (response?.status) {
        const doctorsData = response?.data?.doctors || [];
        const doctorsWithNull = [
          ...doctorsData,
          { doctor_id: null, first_name: "N/A", last_name: "" },
        ];
        setDoctors(doctorsWithNull);
      }
    } catch (error) {
      console.error("Error fetching doctors: ", error);
    }
  };

  const handlefetchPaymentsByClinicId = async () => {
    console.log("selectedStatus...",selectedStatus)
    console.log("selectedPaymentMode..",selectedPaymentMode)
    const clinicId = getClinicIdFromToken();
    const filters = {
      selectedTab,
      startDate: dayjs(startDate).startOf("day").format("YYYY-MM-DD HH:mm:ss Z"),
      endDate: dayjs(endDate).endOf("day").format("YYYY-MM-DD HH:mm:ss Z"),
      paymentMethod: selectedPaymentMode,
      doctorIds: selectedDoctors, // Directly use the array of doctor IDs
      paymentstatus: selectedStatus

    };
    console.log("filters in handleftech",filters)
    const response = await fetchPaymentsByClinicId(clinicId, filters);
    console.log("filters in fetchpayment",filter)
    console.log("status in fetch payment", status)
    if (response?.status) {
      console.log("payment response",response)
      setPayments(response?.data);
      setStatus(response?.data);
    }
  };


  const handleFilterChange = (event) => {
    const value = event.target.value || "";
    setFilterInput(value);
  };

  const handleExport = () => {
    if (payments.length === 0) {
      showToast("No data to export", "error");
      return;
    }
    // Get headers (column names)
    const headers = Object.keys(payments[0]);

    // Convert reports data to CSV format
    const csvData = payments.map((report) => {
      return Object.values(report).join(",");
    });

    // Add headers to the start of the csvData array
    csvData.unshift(headers.join(","));

    // Create a blob containing the CSV data
    const blob = new Blob([csvData.join("\n")], {
      type: "text/csv;charset=utf-8;",
    });

    // Create a temporary URL for the blob
    const url = window.URL.createObjectURL(blob);

    downloadFile(url, "payments.csv");
  };

  // Calculate total amount
  const totalAmount = filteredPayments.reduce(
    (total, payment) => total + parseFloat(payment.amount || 0),
    0
  );

  const breadcrumbs = [
    {
      label: "Home",
      href: "#",
      class: "text-[#2E37A4]",
    },
    { label: "Payment", class: "text-[#2E37A4]" },
  ];

  return (
    <div>
      <div className="page-container relative h-full flex flex-auto flex-col px-4 sm:px-6 py-4 sm:py-6 md:px-8">
        <div className="pt-2 pb-6 flex flex-wrap gap-2 justify-between items-center">
          <MyBreakcrumbs data={breadcrumbs} />
          <div className="inline-flex flex-wrap items-center gap-2">
            <Button
              variant={selectedTab === "today" ? "contained" : "outlined"}
              onClick={() => {
                setSelectedTab("today");
                const today = new Date();
                setStartDate(dayjs(today).startOf("day"));
                setEndDate(dayjs(today).endOf("day"));
              }}
            >
              Today
            </Button>
            <Button
              variant={selectedTab === "yesterday" ? "contained" : "outlined"}
              onClick={() => {
                setSelectedTab("yesterday");
                const yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);
                setStartDate(dayjs(yesterday).startOf("day"));
                setEndDate(dayjs(yesterday).endOf("day"));
              }}
            >
              Yesterday
            </Button>
            <Button
              variant={selectedTab === "custom" ? "contained" : "outlined"}
              onClick={() => {
                if (selectedTab !== "custom") {
                  setSelectedTab("custom");
                  const today = new Date();
                  setStartDate(dayjs(today).startOf("day"));
                  setEndDate(dayjs(today).endOf("day"));
                }
              }}
            >
              Custom
            </Button>
            {selectedTab === "custom" && (
              <>
                <div>
                  <AntDatePicker
                    defaultValue={null}
                    placeholder="select date"
                    value={startDate ? dayjs(startDate) : startDate}
                    onChange={(date, dateString) => {
                      if (endDate && date > endDate) {
                        setEndDate(null);
                      }
                      setStartDate(dateString);
                    }}
                    disabledFutureDate={true}
                    maxDate={dayjs(endDate)}
                  />
                </div>
                <div>
                  <AntDatePicker
                    defaultValue={null}
                    placeholder="select date"
                    value={endDate ? dayjs(endDate) : endDate}
                    onChange={(date, dateStringE) => {
                      if (startDate && date < startDate) {
                        setStartDate(null);
                      }
                      setEndDate(dateStringE);
                    }}
                    minDate={dayjs(startDate)}
                  />
                </div>
              </>
            )}
            <Button
              variant="contained"
              onClick={handleExport}
              style={{ backgroundColor: "#4caf50", color: "white" }}
              startIcon={<CloudDownloadIcon />}
            >
              Export Data
            </Button>
            <SearchInput
              filterInput={filterInput}
              handleFilterChange={handleFilterChange}
            // handleStatusChange={handleStatusChange}
            />
          </div>
        </div>

        <div className="flex border-2 border-gray-300 shadow-lg rounded-lg bg-blue-50 mb-6">
          <div className="flex-1 px-4 py-3">
            <span className="font-normal">Start Date: </span>
            <span className="font-semibold">{formatDateGlobal(startDate, { short: true })}</span>
          </div>
          <div className="flex-1 px-4 py-3">
            <span className="font-normal">Last Date: </span>
            <span className="font-semibold">{formatDateGlobal(endDate, { short: true })}</span>
          </div>
          <div className="flex-1 px-4 py-3">
            <span className="font-normal">Mode: </span>
            <span className="font-semibold">
              {selectedPaymentMode || "All"}
            </span>
          </div>
          <div className="flex-1 px-4 py-3">
            <span className="font-normal">Total Amount: </span>
            <span className="font-semibold">{totalAmount}</span>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-md shadow-gray-200">
          <div className="px-5 py-3 flex flex-wrap md:flex-nowrap justify-between items-center gap-y-5">
            <div className="flex items-center gap-2">
              <div className="text-lg font-semibold text-gray-800">Payment</div>
              <button
                className="md:hidden text-sm px-3 py-1 bg-gray-100 text-gray-600 border border-gray-300 rounded-md"
                onClick={() => setShowFilters(!showFilters)}
              >
                {showFilters ? "Hide Filters" : "Filters"}
              </button>
            </div>
            {/* Desktop: always visible. Mobile: toggle */}
            <div className={`${showFilters ? "flex" : "hidden"} md:flex flex-wrap items-center gap-2 w-full md:w-auto mt-2 md:mt-0`}>
              <CustomSelect
                value={selectedPaymentMode}
                onChange={(selectedOption) => {
                  setSelectedPaymentMode(selectedOption.value);
                }}
                options={paymentMethodOptions}
                isSearchable={false}
                placeholder="Select Method"
                isClearable={false}
                className="w-full md:w-48"
              />

              <DoctorFilterDropdown
                options={doctors.map((doctor) => ({
                  value: doctor.doctor_id,
                  label: doctor.doctor_id
                    ? `${doctor.first_name} ${doctor.last_name}`
                    : "N/A",
                }))}
                selectedOptions={selectedDoctors}
                onChange={setSelectedDoctors}
              />
              <CustomSelect
                value={selectedStatus}
                onChange={(selectedOption) => {
                  setSelectedStatus(selectedOption.value);
                }}
                options={StatusOptions}
                isSearchable={false}
                placeholder="Select Status"
                isClearable={false}
                className="w-full md:w-48"
              />
            </div>
          </div>

          <div className="overflow-auto">
            <MyTable
              columns={columns}
              data={filteredPayments}
              filterInput={filterInput}
              handleFilterChange={handleFilterChange}

            />
          </div>

        </div>
      </div>
    </div>
  );
};

export default Payment;
